<div *ngIf="showGrid">
  <div class="mt-1" *ngFor="let competency of serviceLinesMap">
    <div class="col">
      <div class="card mb-3" style="border-radius: .5rem;">
        <div class="row g-0">
          <div class="col-2 gradient-custom text-center mt-5"
            style="border-top-left-radius: .5rem; border-bottom-left-radius: .5rem;">
            <h5>{{competency.name}}</h5>
          </div>
          <div class="col-10">
            <div class="card-body p-4">
              <h6>Service Lines</h6>
              <hr class="mt-0 mb-4">
              <mat-checkbox *ngFor="let serviceline of competency.serviceLines" [(ngModel)]="serviceline.isSelected"
                (change)="serviceLineChecked($event,competency)">{{serviceline.name}}</mat-checkbox>
              <hr class="mt-0 mb-4" *ngIf="!competency.hideSkillsets">
              <div class="row pt-1" *ngIf="!competency.hideSkillsets">
                <div class="col-6 mb-3">
                  <h6>Mostly Used Skills</h6>
                  <div class="skill-border">
                    <app-typeahead-textbox [disable]="!competency.showSkills" [allValues]="competency.skillSets"
                      [values]="competency.selectedPrimarySkills"
                      (emittedValues)="competency.selectedPrimarySkills=$event" class="custom-typeahead">
                    </app-typeahead-textbox>
                  </div>
                </div>
                <div class="col-6 mb-3">
                  <h6>Rarely Used Skills</h6>
                  <div class="skill-border">
                    <app-typeahead-textbox [disable]="!competency.showSkills" [allValues]="competency.skillSets"
                      [disabled]="!competency.showSkills" [values]="competency.selectedSecondarySkills"
                      (emittedValues)="competency.selectedSecondarySkills=$event" class="custom-typeahead">
                    </app-typeahead-textbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div align="right">
    <button class="save-button" type="submit" (click)="submit()">Save</button>
  </div>
</div>